var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLampIconlyPro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 46,
    viewBox: "0 0 44 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0017 5.27075C22.7611 5.27075 23.3767 5.91435 23.3767 6.70825V6.892C23.3767 7.68591 22.7611 8.3295 22.0017 8.3295C21.2423 8.3295 20.6267 7.68591 20.6267 6.892V6.70825C20.6267 5.91435 21.2423 5.27075 22.0017 5.27075Z",
    fill: "#4FCF45"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.069 10.4386C10.6059 9.87723 11.4766 9.87723 12.0135 10.4386L12.1378 10.5685C12.6748 11.1299 12.6748 12.0401 12.1378 12.6015C11.6008 13.1628 10.7302 13.1628 10.1933 12.6015L10.069 12.4715C9.53202 11.9102 9.53202 11 10.069 10.4386Z",
    fill: "#4FCF45"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9331 12.4716C34.4701 11.9102 34.4701 11 33.9331 10.4386C33.3962 9.87723 32.5257 9.87723 31.9887 10.4386L31.8644 10.5685C31.3274 11.1299 31.3274 12.0401 31.8644 12.6015C32.4014 13.1628 33.272 13.1628 33.8088 12.6015L33.9331 12.4716Z",
    fill: "#4FCF45"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.12524 22.9138C5.12524 22.1199 5.74084 21.4763 6.50024 21.4763H6.67601C7.43539 21.4763 8.05101 22.1199 8.05101 22.9138C8.05101 23.7077 7.43539 24.3513 6.67601 24.3513H6.50024C5.74084 24.3513 5.12524 23.7077 5.12524 22.9138Z",
    fill: "#4FCF45"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.364 21.4763C36.6046 21.4763 35.989 22.1199 35.989 22.9138C35.989 23.7077 36.6046 24.3513 37.364 24.3513H37.4989C38.2583 24.3513 38.8739 23.7077 38.8739 22.9138C38.8739 22.1199 38.2583 21.4763 37.4989 21.4763H37.364Z",
    fill: "#4FCF45"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1094 33.2536C12.6464 33.815 12.6464 34.7252 12.1094 35.2866L12.0135 35.3868C11.4766 35.9482 10.6059 35.9482 10.069 35.3868C9.53202 34.8254 9.53202 33.9152 10.069 33.3538L10.1649 33.2536C10.7018 32.6922 11.5724 32.6922 12.1094 33.2536Z",
    fill: "#57DD57"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8364 33.2536C33.2994 32.6922 32.4287 32.6922 31.8918 33.2536C31.3548 33.815 31.3548 34.7252 31.8918 35.2866L31.9876 35.3868C32.5246 35.9482 33.3953 35.9482 33.9322 35.3868C34.469 34.8254 34.469 33.9152 33.9322 33.3538L33.8364 33.2536Z",
    fill: "#4FCF45"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3414 33.5417C12.7757 31.515 10.3555 27.5602 10.3555 23.0079C10.3555 15.5321 16.8862 9.66875 24.2741 11.2348C28.6653 12.1744 32.213 15.8571 33.1294 20.4513C34.2271 25.9822 31.6408 31.1259 27.4435 33.5417H16.3414Z",
    fill: "#4FCF45"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9627 35.4583V36.8501C26.9627 39.7778 24.6755 42.1666 21.8774 42.1666C19.0794 42.1666 16.7922 39.7778 16.7922 36.8501V35.4583H26.9627Z",
    fill: "#4FCF45"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLampIconlyPro);
export default __webpack_public_path__ + "static/media/Lamp - Iconly Pro.0cd4c90ad6f80156efb411d7249a496b.svg";
export { ForwardRef as ReactComponent };